import { GENERATE_LANDING_PAGE_FORM, UPDATE_LANDING_FORM_INPUT } from '../../actions/landingPage';

export const initialState = {
  landingForm: {},
  validationPatterns: {},
  localizedValidationPatterns: null,
};

export default (
  state = initialState,
  {
    type,
    data: {
      landingForm,
      validationPatterns,
      localizedValidationPatterns,
      inputKey,
      inputValue,
    } = {},
  } = {},
) => {
  switch (type) {
    case GENERATE_LANDING_PAGE_FORM:
      return {
        ...state,
        landingForm,
        validationPatterns,
        localizedValidationPatterns,
      };

    case UPDATE_LANDING_FORM_INPUT:
      return {
        ...state,
        landingForm: {
          ...state.landingForm,
          [inputKey]: inputValue,
        },
      };

    default:
      return state;
  }
};
